import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
`;

const ContentDescription = styled.div`
  color: var(--color-accent-secondary-default);
  font-size: 20px;
  line-height: 150%;
  margin-bottom: 3.2rem;
`;

const LeftCol = styled.div``;

const RightCol = styled.div``;

const Ul = styled.ul`
  counter-reset: list;
  display: table;
  list-style-position: inside;
`;

const Li = styled.li`
  counter-increment: list;
  display: table-row;
  list-style-position: inside;
  list-style-type: decimal;

  &::before {
    content: counter(list) '.';
    display: table-cell;
    padding-left: 8px;
    padding-right: 4px;
    text-align: right;
  }
`;

export { Content, ContentDescription, LeftCol, Li, RightCol, Ul };
